import { render } from "./GridCerinte.vue?vue&type=template&id=0c50e536&ts=true"
import script from "./GridCerinte.vue?vue&type=script&lang=ts"
export * from "./GridCerinte.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__